export default defineNuxtRouteMiddleware((to) => {
  const { isAuthenticated } = useSanctumAuth()
  if (!isAuthenticated.value) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})
